module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-light-300.svg?4433b4f4806f7bfb430596701dd4fde8";